import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrdersState, Order } from './orderModels';
import { createOrder } from './orderThunks';

const initialState: OrdersState = {
  currentOrder: null,
  orderHistory: [],
  loading: false,
  error: null,
  status: 'idle',
  successMessage: null,
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    clearCurrentOrder: (state) => {
      state.currentOrder = null;
      state.successMessage = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    addToOrderHistory: (state, action: PayloadAction<Order>) => {
      state.orderHistory.push(action.payload);
    },
    clearOrderHistory: (state) => {
      state.orderHistory = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
        state.status = 'loading';
        state.error = null;
        state.successMessage = null;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.currentOrder = action.payload.order;
        state.successMessage = action.payload.message;
        state.orderHistory.push(action.payload.order);
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false;
        state.status = 'failed';
        state.error = action.payload || 'Failed to create order';
      });
  },
});

export const {
  clearCurrentOrder,
  clearError,
  addToOrderHistory,
  clearOrderHistory,
} = ordersSlice.actions;

export default ordersSlice.reducer;

